import imgIzzi61 from "./img-izzi6 (1).png";
import imgIzzi62 from "./img-izzi6 (2).png";
import imgIzzi63 from "./img-izzi6 (3).png";
import imgIzzi64 from "./img-izzi6 (4).png";
import imgIzzi65 from "./img-izzi6 (5).png";
import imgIzzi66 from "./img-izzi6 (6).png";
import imgIzzi67 from "./img-izzi6 (7).png";
import imgIzzi68 from "./img-izzi6 (8).png";
import imgIzzi69 from "./img-izzi6 (9).png";
import imgIzzi610 from "./img-izzi6 (10).png";

const imgIzzi6 = [
  imgIzzi61,
  imgIzzi62,
  imgIzzi63,
  imgIzzi64,
  imgIzzi65,
  imgIzzi66,
  imgIzzi67,
  imgIzzi68,
  imgIzzi69,
  imgIzzi610,
];

export default imgIzzi6;
